import { AgmCoreModule } from "@agm/core";
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FuseSidebarModule, FuseWidgetModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "app/pipes/pipes.module";
import { ShiftService } from "app/services/shift.service";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { ShiftContainerListComponent } from "./shift-container-list/shift-container-list.component";
import { ShiftComponent } from "./shift-form/shift.component";
import { ShiftListComponent } from "./shift-list/shift-list.component";


@NgModule({
    declarations: [ShiftComponent,ShiftListComponent,ShiftContainerListComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        NgxMatTimepickerModule,
        NgxMatDatetimePickerModule,
        NgxMatNativeDateModule,
        MatMenuModule,
        MatSelectModule,
        MatTableModule,
        BrowserAnimationsModule,
        MatCheckboxModule,
        FuseSharedModule,
        MatTooltipModule,
        MatProgressBarModule,
        FuseSidebarModule,
        FuseWidgetModule,
        MatChipsModule,
        MatExpansionModule,
        MatStepperModule,
        MatInputModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatRippleModule,
        MatRadioModule,
        MatSortModule,
        MatTabsModule,
        MatSnackBarModule,
        MatIconModule,
        PipesModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        TranslateModule,
        FormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
        })
    ],
    providers: [ShiftService]
})
export class ShiftModule { }
